import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['ToyManager']['getSingleByDraft']
type inputType = RouterInputs['ToyManager']['getSingleByDraft']

export const useGetSingleByDraft = (input: inputType, options?: optionsType) =>
    api.ToyManager.getSingleByDraft.useQuery(input, {
        ...options,
        queryKey: ['ToyManager.getSingleByDraft', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
    })
